/* --- Parallax --- */

	// -- Header
	var parallaxHeader = throttle(function (){

		var header = document.getElementsByTagName('header')[0];
		//var headerVideo = header.getElementsByTagName('video')[0];

		// If we are below the header
		if(pastHeader()){
			header.classList.add('is-hidden'); // Hide the header
			//headerVideo.pause(); // Pause the video

		// We are in the header
		} else {
			header.classList.remove('is-hidden'); // Show the header
			//headerVideo.play(); // Play the video
		}
	}, 100);

	// -- Footer
	var parallaxFooter = throttle(function (){

		var footer = document.getElementsByTagName('footer')[0];

		// Set the height of the footer
		footer.style.height = footer.getElementsByClassName('parallax')[0].getBoundingClientRect().height + 'px';

		var lastSectionPosition = document.querySelector('#tbe-201610 article > section:last-of-type').getBoundingClientRect().top;

		if(lastSectionPosition > window.innerHeight ){ // If the footer is in view
			footer.classList.add('is-hidden'); // Hide the footer
		} else { // We are in the last Section
			footer.classList.remove('is-hidden'); // Show the footer
		}
	}, 100);

	// -- Curtain effect
	var parallaxCurtain = function (){

		// Default
		var trigger = false;
		var orientation = 'curtain-bottom';

		var curtains = document.querySelectorAll('#tbe-201610 .curtain');

		// check for each possible curtain
		for (var i = curtains.length - 1; i >= 0; i--) {

			// Get the figure
			var figure = curtains[i].getElementsByTagName('figure')[0];

			// Dimensions of the curtain
			var dimensions = curtains[i].getBoundingClientRect();

			// If the image is taller than the screen then bottom trigger
			if(dimensions.height > window.innerHeight){

				if(dimensions.bottom <= window.innerHeight &&	dimensions.bottom > 0){
					trigger = true;
					orientation = 'curtain-bottom';
				}

			// the image is smaller than the screen so top trigger
			} else {

				if(dimensions.top <= 0 && dimensions.bottom > 0){
					trigger = true;
					orientation = 'curtain-top';
				}
			}

			// Make the figure Fixed
			if(trigger){
				figure.classList.add('curtain-active');
				figure.classList.add(orientation);
				curtains[i].style.height = figure.getBoundingClientRect().height + 'px';

			// Or Relative again
			} else {
				figure.classList.remove('curtain-active');
				figure.classList.remove('curtain-top');
				figure.classList.remove('curtain-bottom');
			}

		} // End for
	}

	// Setup Safari exception
	document.addEventListener('DOMContentLoaded', function(){
		// We know that Javascript is on, and that we aren't on safari
		var isSafari = false;
		isSafari = navigator.userAgent.indexOf("Safari") > 0 && navigator.userAgent.indexOf("Chrome") < 0;
		if(!isSafari){
			document.getElementById('tbe-201610').classList.add('fixed');
		}
	},false);

	// -- Scroll call
	function parallax(){

		// Header & Footer
		parallaxHeader();
		parallaxFooter();

		// Curtain effect
		var curtains = document.querySelectorAll('#tbe-201610 .curtain');
		if(curtains.length > 0){
			parallaxCurtain();
		}
	}

/* --- End - Parallax --- */
